import { Box, Typography, useTheme } from '@material-ui/core';
import React, { ReactNode } from 'react';
import useGenericStyles from 'src/styles/useGenericStyles';
import NotificationsWidget from './dashboard/NotificationsWidget';
import AccountPopover from './dashboard/AccountPopover';
import AddIcon from '@material-ui/icons/Add';
import Logo from './Logo';
import { CustomButton2 } from './widgets/buttons/CustomButton2';
import { Chat } from '@material-ui/icons';
import { useNavigate } from 'react-router';
import LinksWidget from './dashboard/LinksWidget';

interface HeaderProps {
  title?: string;
  children?: ReactNode | undefined;
}

export const Header = ({ title, children }: HeaderProps) => {
  const classes = useGenericStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        height: '64px',
        padding: '20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        left: 0,
        right: 0,
        top: 0,
        zIndex: 1000,
        boxShadow: 1,
      }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ cursor: 'pointer' }} onClick={() => navigate('/cases/dashboard')}>
          <Logo width={100} height={100} />
        </Box>
        <Typography variant="h5" className={classes.headerHeading}>
          {title}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flexDirection: 'row' }}>
        <CustomButton2
          backgroundColor={theme.palette.primary.main}
          className={classes.button}
          onClick={() => navigate('/cases/add')}>
          <AddIcon
            sx={{
              marginRight: '5px',
            }}
          />
          Create case
        </CustomButton2>
        {children}
        <LinksWidget />
        <NotificationsWidget />
        <Chat
          sx={{ color: '#718096', cursor: 'pointer' }}
          onClick={() => navigate('/chats-history')}
        />
        <AccountPopover />
      </Box>
    </Box>
  );
};
